import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import '../styles/contact.css'

import mobile from '../assets/icons/phone_iphone.svg'
import mail from '../assets/icons/mail.svg'
import location from '../assets/icons/map.svg'
import contactImage from '../assets/images/bnw-09.jpg'

import Helmet from '../components/Helmet/Helmet';

const Contact = () => {


    const [formData, setFormData] = useState({
        name: '',
        email: '',
        comment: ''
      });
      const [errors, setErrors] = useState({});
      
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    
        if (value.trim() === '') {
          setErrors({ ...errors, [name]: `${name.charAt(0).toUpperCase() + name.slice(1)} is required` });
        } else if (name === 'email' && !/^\S+@\S+\.\S+$/.test(value)) {
          setErrors({ ...errors, [name]: 'Invalid email address' });
        } else {
          setErrors({ ...errors, [name]: '' });
        }
      };


  return<Helmet title={'Contact'}>
  <section className="contact __black">
    <div className="w-1">
        <h1 className='__h1 e contactus'>Contacts</h1>
    </div>
    <div className="w-1 fsa contactSocialMedia">
        <div className="contact__media">
            <span className="contact__circle">
                <img className='socialIcon' src={mobile} alt="" />
            </span>
            <Link target='_blank' to='https://wa.me/779415754' className='contactLinks'>+94 77 941 5754</Link>
        </div>
        <div className="contact__media">
            <span className="contact__circle">
                <img className='socialIcon' src={mail} alt="" />
            </span>
            <Link target='_blank' to='mailto:contact@ravisarajayamanna.com' className='contactLinks'>contact@ravisarajayamanna.com</Link>
        </div>
        <div className="contact__media">
            <span className="contact__circle">
                <img className='socialIcon' src={location} alt="" />
            </span>
            <Link className='contactLinks'>Colombo, Sri Lanka</Link>
        </div>
    </div>
    <div className="w-1 contact__form-section fsba">
        <div className="contact_img">
            <img src={contactImage} alt="" />
        </div>
        <div className="contact__form">
            <h1>Drop me a line</h1>
            <p>Fill out the form or alternatively send an email to <Link target='_blank' to='mailto:contact@ravisarajayamanna.com'>contact@ravisarajayamanna.com</Link></p>
            <p>We normally reply within 24 hours, except for weekends. If your message appears urgent, we will reply sooner.</p>
          <form className='contact__page-form'>
            <input
              className='form__fields'
              type="text"
              name="name"
              placeholder='Enter your name'
              value={formData.name}
              onChange={handleChange}
            />
            {errors.name && <p className="error">{errors.name}</p>}
            <input
              className='form__fields'
              type="email"
              name="email"
              placeholder='Enter your e-mail'
              value={formData.email}
              onChange={handleChange}
            />
            {errors.email && <p className="error">{errors.email}</p>}
            <textarea
              className='form__fields'
              name="comment"
              placeholder='Enter your comment'
              value={formData.comment}
              onChange={handleChange}
            />
            {errors.comment && <p className="error">{errors.comment}</p>}
            <button className='contact__form-button'>Subscribe</button>
          </form>
        </div>
    </div>
  </section>
  </Helmet> 
}

export default Contact